export const PAGINATION_PAGE_SIZE_OPTIONS = [10, 20, 50];
export const PAGINATION_DEFAULT_PAGE_SIZE = 10;
export const PAGINATION_DEFAULT_PAGE = 1;

export const PAGINATION_DEFAULT_STATE = {
  page: PAGINATION_DEFAULT_PAGE,
  pageSize: PAGINATION_DEFAULT_PAGE_SIZE,
};

export type PaginationPageSizeOption =
  (typeof PAGINATION_PAGE_SIZE_OPTIONS)[number];
